document.addEventListener("click", function (e) {
  // Generic +/- quantity stepper (snippets/product-form.liquid), works on
  // any [data-qty-stepper] wrapper containing a [data-quantity-input].
  var button = e.target.closest("[data-qty-decrease], [data-qty-increase]");
  if (!button) return;

  var stepper = button.closest("[data-qty-stepper]");
  var input = stepper && stepper.querySelector("[data-quantity-input]");
  if (!input) return;

  var value = parseInt(input.value, 10);
  if (isNaN(value)) value = 1;

  if (button.hasAttribute("data-qty-decrease")) {
    value = Math.max(1, value - 1);
  } else {
    var max = parseInt(input.getAttribute("max"), 10);
    value = isNaN(max) ? value + 1 : Math.min(max, value + 1);
  }

  input.value = value;
  input.dispatchEvent(new Event("change", { bubbles: true }));
});

document.addEventListener("DOMContentLoaded", function () {
  // "View Bulk Order Grid" toggle (snippets/product-form.liquid) - the grid
  // itself (snippets/variant-order-form.liquid, #bulk-order-section) is
  // hidden by default via CSS (max-height: 0) and expands/collapses here.
  var toggleBtn = document.querySelector(".bulk-order-toggle");
  var bulkSection = document.querySelector("#bulk-order-section");
  var toggleBtnText = toggleBtn && toggleBtn.querySelector(".atc-button--text");

  if (!toggleBtn || !bulkSection) return;

  function expandSection() {
    bulkSection.classList.add("active");
    bulkSection.style.maxHeight = bulkSection.scrollHeight + "px";
    (toggleBtnText || toggleBtn).textContent = "Hide Bulk Order Grid";
  }

  function collapseSection() {
    bulkSection.style.maxHeight = 0;
    bulkSection.classList.remove("active");
    (toggleBtnText || toggleBtn).textContent = "View Bulk Order Grid";
  }

  toggleBtn.addEventListener("click", function () {
    if (bulkSection.classList.contains("active")) {
      collapseSection();
    } else {
      expandSection();
    }
  });

  window.addEventListener("resize", function () {
    if (bulkSection.classList.contains("active")) {
      bulkSection.style.maxHeight = bulkSection.scrollHeight + "px";
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // empire.js's ProductDetails._updateButton() runs on every variant change
  // and does $productAtcButton.text(...) directly on the <button> - jQuery's
  // .text() replaces ALL child nodes with a single text node, wiping out
  // both the icon-shopping-bag SVG + .atc-button--text wrapper (product-form.liquid)
  // and the .atc-button--icon spinner span. Rebuild them here instead of
  // patching the vendor bundle - a MutationObserver catches every call site
  // (variant change, disabled toggling, etc.) without needing to hook the
  // vendor's own variant-change event.
  var atcButton = document.querySelector("[data-product-atc]");
  if (!atcButton) return;

  var iconEl = atcButton.querySelector(".atc-button--text svg");
  var iconMarkup = iconEl ? iconEl.outerHTML : "";

  var spinnerEl = atcButton.querySelector(".atc-button--icon");
  var spinnerMarkup = spinnerEl ? spinnerEl.outerHTML : "";

  function restoreAtcButtonMarkup() {
    if (atcButton.querySelector(".atc-button--text")) return;

    var label = atcButton.textContent.trim();
    var isAvailable = !atcButton.disabled && !atcButton.classList.contains("disabled");

    atcButton.innerHTML =
      '<span class="atc-button--text">' + (isAvailable ? iconMarkup : "") + label + "</span>" +
      spinnerMarkup;
  }

  new MutationObserver(restoreAtcButtonMarkup).observe(atcButton, {
    childList: true,
    characterData: true,
    subtree: true,
  });
});
